// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"89dbdb30","416":"1db26428","437":"307d3b38","510":"08874ee2","789":"1761938d","988":"87defa68","998":"84b4fcc3"}[chunkId] + ".chunk.js";
};